import { GET_DISBURSEMENT_REJECTION_REPORT } from "../../../Types";

const DisbursementRejectionReportReducer = (state = [], action) => {
  switch (action.type) {
    case GET_DISBURSEMENT_REJECTION_REPORT:
      return action.payload;

    default:
      return state;
  }
};
export default DisbursementRejectionReportReducer;
